export default __webpack_public_path__ + "static/media/tourism-icon.c4df19a7.svg";